const REGEX =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/iu;

export function uuidVersion(uuid: string) {
  if (!REGEX.test(uuid)) throw new TypeError("Invalid UUID");
  return Number.parseInt(uuid.slice(14, 15), 16);
}
